import { render } from "./CrossButton.vue?vue&type=template&id=4539b60a&scoped=true"
import script from "./CrossButton.vue?vue&type=script&lang=js"
export * from "./CrossButton.vue?vue&type=script&lang=js"

import "./CrossButton.vue?vue&type=style&index=0&id=4539b60a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-4539b60a"

export default script